import {cDisplay} from '../creator/cDisplay'
import { cGame } from '../creator/cGame';
import { cButton } from '../creator/cGameObjects/cButton';
import { addCoinAnimation } from '../creator/cDisplayObjects/EvaluationCard';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';
import { net } from '../creator/utils/net';

import * as md5 from 'md5';
import { cText } from '../creator/cGameObjects/cText';
import { cContainer } from "../creator/cGameObjects/cContainer";
import { getStr } from "../creator/utils/simpleLocalisation";

export class tvDisplay extends cDisplay {

  private curData: any;
  private dots: any[]
  private dataText: any;

  init(){
    super.init();

    console.log('TV display');

    //tasks
    (this.scene as cScene).ev.addListener('action',(command,options)=>{
      switch (options.command ){
        case 'fill_dots':
          var tg = this.getByName('seat_holder') as cContainer
          var i = 0;
          var done:boolean = false
          tg.each((e)=>{  
            this.scene.add.tween({
              targets:[e],
              alpha:1,
              duration: 300,
              delay: (i++)*10,
            })
          });
          break;
        case 'comment':
          (this.scene as cScene).triggerSceneEvent('result', this.dataText)
          break;

      }
    })    
    
  }

  buildScene(){
    super.buildScene();
    this.buildSeats(this.getRandomBuildData())
  }

  getRandomBuildData(){
    var res = {}
    var parties = {
      'ulf': [24,49],
      'bunte': [2,55],
      'pas': [1,12],
      'qpd':[3,3],
      'tuba':[1,1]
    };

    return parties;

    // var score = []
    // var max = 100;

    // parties.forEach( (val)=>{
    //   var n:number = Math.round(Math.random() * max)
    //   if (n > 35) n = 35 + (Math.round(Math.random()*6 )) - 3
    //   console.log(n)
    //   max -= n
    //   res[val] = (val === 'dss') ? max : n
    // })


    // return res
  }

  buildSeats(data){
    var tg = this.getByName('seat_holder') as cContainer
    var total = Object.keys(data).reduce( (acc,val)=>{return acc+data[val]},0);
    var winnerParty = ''
    var winnerCount = 0

    Object.keys(data).forEach( (partyName)=>{
      var count = data[partyName][1];
      var direct = data[partyName][0];
      var txt = this.getByName('value_'+partyName) as cText
      txt.textdata = count+'';
      if (count > winnerCount){
        winnerCount = count
        winnerParty = partyName
      }
      for (var a=0; a < count;a++){
        var nm = '';//(a < direct) ? '_direkt' : '';
        var q = new Phaser.GameObjects.Sprite(this.scene,0,0,'seat_dot',partyName+nm+'.png')
        q.alpha = 0
        tg.add(q)
      }
    })
    tg.arrange();

    var winnerBubble = getStr('bubble.winner')
    winnerBubble = String(winnerBubble).replace('[party]',winnerParty);
    this.dataText = {party:winnerParty, score:winnerCount, bubble: winnerBubble};
  }



  
}

